import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useBulkUpdateBudgetAllocation } from 'modules/finance/hooks/useBudgetAllocations'

interface RemoveAllocationModalProps {
  closeModal: () => void
  budgetId: string
  allocationIds: string[]
  periodStart: string
  refetchBudget: (param: { id: string; periodStart: string }) => void
}

const RemoveAllocationModal = ({
  closeModal,
  budgetId,
  allocationIds,
  periodStart,
  refetchBudget,
}: RemoveAllocationModalProps) => {
  const { bulkUpdateBudgetAllocation } = useBulkUpdateBudgetAllocation({
    budgetId,
  })
  const handleSubmit = async () => {
    const response = await bulkUpdateBudgetAllocation({
      ids: allocationIds,
      budgetId: budgetId,
      amountCents: undefined,
    })

    const result = handleResult(response, (_) => {})
    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('budgets.detail.delete_allocation_modal.submit_success'),
      })
      refetchBudget({ id: budgetId, periodStart })
      closeModal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('budgets.detail.delete_allocation_modal.submit_error'),
      })
    }
    return result
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('budgets.detail.delete_allocation_modal.title')}
      description={i18n.t('budgets.detail.delete_allocation_modal.description')}
      onSubmit={handleSubmit}
      onClose={closeModal}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.close')}
          </Button>
          <Button submit>{i18n.t('common.remove')}</Button>
        </>
      }
    />
  )
}

export default RemoveAllocationModal
